import React, { useCallback, useState, useMemo } from 'react';
import { Form } from 'semantic-ui-react';
import { Link, useHistory } from 'react-router-dom';
import PasswordRevealerInput from 'components/PasswordRevealerInput/PasswordRevealerInput';
import { withAuthLayout } from 'layouts/AuthLayout/AuthLayout';
import { useAlert } from 'context/AlertProvider';
import { resetPassword } from 'services/auth.service';
import useInput from 'hooks/useInput';

function ResetPasswordPage(props) {
  const alert = useAlert();
  const history = useHistory();
  const [username, setUsername] = useInput();
  const [password, setPassword] = useInput();
  const [code, setCode] = useInput();
  const [loading, setLoading] = useState(false);

  const errorTranslations = useMemo(
    () => ({
      'Invalid code provided, please request a code again.':
        'El código de recuperación no es válido. Por favor introduce un código válido o solicítalo de nuevo.',
      'Password does not conform to policy: Password must have numeric characters':
        'La contraseña no cumple con la política de seguridad: tiene que tener caracteres numéricos.',
      'Password does not conform to policy: Password must have uppercase characters':
        'El password no cumple con la política de seguridad: Debe contener alguna mayúscula.',
      'Password does not conform to policy: Password not long enough':
        'El password no cumple con la política de seguridad: No es lo suficientemente largo.',
      "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6":
        'Error de validación de la contraseña: debe tener al menos 6 caracteres',
      'Attempt limit exceeded, please try after some time.':
        'Límite de intentos superado, por favor inténtalo más tarde.',
    }),
    [],
  );

  const submitHandler = useCallback(
    async (username, code, password) => {
      try {
        setLoading(true);
        await resetPassword(username, code, password);
        alert.current.message(
          'Proceso de recuperación de contraseña finalizado con éxito',
          () => history.push('/login'),
        );
      } catch (error) {
        console.error(error);
        if (error.message) {
          alert.current.error(
            errorTranslations[error.message] ??
              'Error recuperando la contraseña',
          );
        } else {
          alert.current.error('Error recuperando la contraseña');
        }
        setLoading(false);
      }
    },
    [errorTranslations, history, alert],
  );

  return (
    <>
      <h1>Restablecer contraseña</h1>
      <Form>
        <Form.Input
          required
          value={username}
          onChange={setUsername}
          className="username"
          label="E-mail"
          autoComplete="new-password"
        />
        <PasswordRevealerInput
          required
          value={password}
          onChange={setPassword}
          className="password"
          label="Contraseña"
          autoComplete="new-password"
        />
        <Form.Input
          required
          value={code}
          onChange={setCode}
          className="code"
          label="Código de recuperación"
          autoComplete="new-password"
        />
        <Form.Button
          className="login-button"
          primary
          fluid
          type="submit"
          disabled={!username || !password || !code || loading}
          loading={loading}
          onClick={(event, data) => submitHandler(username, code, password)}
        >
          Restablecer
        </Form.Button>
      </Form>
      <footer className="auth-layout__footer">
        <Link to="/login">Volver</Link>
      </footer>
    </>
  );
}

export default withAuthLayout(ResetPasswordPage);
